<!-- GLOBAL LOADER CURRENTLY REMOVED -->
<!-- <app-global-loader></app-global-loader> -->

<!-- Toaster Notifications -->
<ngx-sonner-toaster
  position="top-right"
  [closeButton]="true"
  [visibleToasts]="10"
  [toastOptions]="toastOptions">
</ngx-sonner-toaster>

<!-- Not Logged In -->
@if (!(isAuth$ | async)) {
  @if (showLoadSpinner) {
    <div class="login-spinner-container">
      <mat-spinner color="accent"></mat-spinner>
    </div>
  }
  <router-outlet></router-outlet>
}

<!-- Logged In -->
@if (isAuth$ | async) {
  <!-- ngIf = "{isHandheld: isHandheld$ | async} as vp" will always return truthy => using to extract vp as variable -->
  @if ({ isHandheld: isHandheld$ | async }; as vp) {
    <mat-sidenav-container class="sidenav-container">
      <mat-sidenav
        [ngClass]="{ 'sidenav-web': !vp.isHandheld, 'sidenav-mobile': vp.isHandheld }"
        [opened]="!vp.isHandheld"
        [mode]="vp.isHandheld ? 'over' : 'side'"
        [disableClose]="vp.isHandheld ? false : true"
        #sidenav>
        <app-sidenav
          (linkClick)="vp.isHandheld ? sidenav.close() : ''">
        </app-sidenav>
      </mat-sidenav>
      <mat-sidenav-content class="sidenav-content">
        <div class="content-container">
          <header>
            <app-header
              [helpIsLoading$]="helpIsLoading$"
              [caseComIsLoading$]="caseComIsLoading$"
              (menuClick)="sidenav.open()"
              (helpClick)="toggleHelp()"
              (emailClick)="setCaseId($event);toggleCaseCom($event)">
            </app-header>
          </header>
          <main [attr.aria-busy]="showLoadSpinner">
            <mat-drawer-container class="help-container">
              <mat-drawer #helpDrawer class="help-drawer" mode="over" position="end" [opened]="drawerOpen" (openedChange)="onOpenedChange($event)">
                @if (helpData$ | async; as data) {
                  <app-help
                    [helpAndFeedback]="data"
                    (closeHelp)="toggleHelp()">
                  </app-help>
                }
                @if (caseComDrawer$ | async; as data) {
                  <app-case-communication-drawer
                    [caseComData]="data"
                    [caseId]="caseId"
                    (closeCaseCom)="toggleCaseCom()">
                  </app-case-communication-drawer>
                }
              </mat-drawer>
              <!-- routing: the spinner replaces the page -->
              @if (showLoadSpinner && !showLoadOverlay) {
                <div class="spinner-container">
                  <mat-spinner color="accent"></mat-spinner>
                </div>
              } @else {
                <router-outlet></router-outlet>
              }
            </mat-drawer-container>
            <!-- dashboard widget dialogs: over the page rather than replacing it, so the page (and whatever has focus) survives the load -->
            @if (showLoadSpinner && showLoadOverlay) {
              <div class="page-loader">
                <mat-spinner color="accent"></mat-spinner>
              </div>
            }
          </main>
        </div>
      </mat-sidenav-content>
    </mat-sidenav-container>
  }
}
